<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'
import { get } from 'lodash'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['items']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              required: true
            }),
            {
              component: 'h3',
              innerText: 'Elementy'
            },
            new fields.Formset({
              modelPath: [this, 'form', 'items'],
              blankObject: { rows: [] },
              items: this.form.items.map((item, i) => ({
                headerLabel: get(item, ['left_column']),
                fields: [
                  new fields.Input({
                    label: 'Opis',
                    modelPath: [this, 'form', 'items', i, 'description']
                  }),
                  new fields.Image({
                    label: 'Zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'image']
                  }),
                  new fields.Switch({
                    label: 'Czarno-białe zdjęcie',
                    modelPath: [this, 'form', 'items', i, 'is_black_and_white']
                  }),
                  {
                    component: 'h3',
                    innerText: 'Wiersze'
                  },
                  new fields.Formset({
                    modelPath: [this, 'form', 'items', i, 'rows'],
                    items: this.form.items[i].rows.map((row, rowIndex) => ({
                      headerLabel: get(item, ['left_column']),
                      fields: [
                        new fields.Input({
                          label: 'Kolumna 1',
                          modelPath: [
                            this,
                            'form',
                            'items',
                            i,
                            'rows',
                            rowIndex,
                            'column_1'
                          ]
                        }),
                        new fields.Input({
                          label: 'Kolumna 2',
                          modelPath: [
                            this,
                            'form',
                            'items',
                            i,
                            'rows',
                            rowIndex,
                            'column_2'
                          ]
                        })
                      ]
                    }))
                  })
                ]
              }))
            })
          ]
        }
      ]
    }
  }
}
</script>
